import { BUNDLE_INVENTORY_GET_REQUEST } from '../actionTypes/BundleInventoryActionTypes';

const getInventoryAction = (payload) => ({
    type: BUNDLE_INVENTORY_GET_REQUEST,
    payload,
});

export default getInventoryAction;
